// Layouts
import AuthLayout from "../../layouts/Auth";
import LeapDashboardLayout from "../../layouts/LeapDashboard";

import LicenceProfile from "../../leap-dashboards/LicenceProfile";

// Auth
import Page404 from "../../pages/auth/Page404";

// Protected routes
import LicenceDashboard from "../../leap-pages/LicenceProfile";
import SiteVisit from "../../leap-pages/LicenceProfile/SiteVisits";
import Confirm from "../../leap-pages/Confirm";
import ComplianceTab from "../../leap-pages/LicenceProfile/ComplianceTab";
import LicenceVersionsTab from "../../leap-pages/LicenceProfile/LicenceVersionsTab";
import LicenseeReturn from "../../leap-pages/LicenceProfile/LicenseeReturn";
import RequestForInformation from "../../leap-pages/LicenceProfile/RequestForInformation";
import FindingAndRecommendation from "../../leap-pages/LicenceProfile/FindingAndRecommendation";
import Instruction from "../../leap-pages/LicenceProfile/Instruction";
import EdenMessage from "../../leap-pages/LicenceProfile/EdenMessage";
import LeapHome from "../../leap-pages/LeapHome";
import ComplianceInvestigation from "../../leap-pages/LicenceProfile/ComplianceInvestigation";
import Incident from "../../leap-pages/LicenceProfile/Incident";
import Complaint from "../../leap-pages/LicenceProfile/Complaint";
import IncidentUpdateRequest from "../../leap-pages/LicenceProfile/IncidentUpdateRequest";
import Meeting from "../../leap-pages/LicenceProfile/Meeting";
import NonCompliance from "../../leap-pages/LicenceProfile/NonCompliance";
import ActionOrInstruction from "../../leap-pages/LicenceProfile/ComplianceInvestigation/ActionsOrInstructions";
import EpaCorrespondence from "../../leap-pages/LicenceProfile/EpaCorrespondence";
import ThirdPartyCorrespondence from "../../leap-pages/LicenceProfile/ThirdPartyCorrespondence";
import Page500 from "../../pages/auth/Page500";
import AbstractionList from "../abstraction/pages/List";
import AbstractionDetails from "../abstraction/pages/Details";
import EtsList from "../ets/pages/List";
import Licence from "../../leap-pages/LicenceProfile/Licence";
import LicenceAction from "../../leap-pages/LicenceProfile/LicenceAction";
import Submission from "../../leap-pages/LicenceProfile/Submission";
import ChangeRequest from "../../leap-pages/LicenceProfile/ChangeRequest";
import LicenceTransfer from "../../leap-pages/LicenceProfile/LicenceTransfer";
import EnvironmentalLiabilitiesTab from "../../leap-pages/LicenceProfile/EnvironmentalLiabilitiesTab";

const routes = [
  {
    path: "/",
    element: <LeapDashboardLayout />,
    children: [
      {
        path: "",
        element: <LeapHome />,
      },
      {
        path: "confirm",
        element: <Confirm />,
      },
      {
        path: "404",
        element: <Page404 />,
      },
      {
        path: "500",
        element: <Page500 />,
      },
      {
        path: "ets",
        element: <EtsList />,
      },
      {
        path: "abstractions",
        element: <AbstractionList />,
      },
      {
        path: "abstractions",
        element: <AbstractionList />,
      },
      {
        path: "abstractions/:regNo",
        element: <AbstractionDetails />,
      },
      {
        path: "licence-profile/:profileNo",
        element: <LicenceProfile />,
        children: [
          {
            path: "",
            element: <LicenceDashboard />,
          },
          {
            path: "compliance",
            element: <ComplianceTab />,
          },
          {
            path: "versions",
            element: <LicenceVersionsTab />,
          },
          {
            path: "environmental",
            element: <EnvironmentalLiabilitiesTab />,
          },
          {
            path: "versions/:licenceId",
            element: <Licence />,
          },
          {
            path: "versions/:licenceId/licensing-actions/:licenceActionId",
            element: <LicenceAction />,
          },
          {
            path: "versions/:licenceId/submissions/:submissionId",
            element: <Submission />,
          },
          {
            path: "versions/:licenceId/change-request/:changeRequestId",
            element: <ChangeRequest />,
          },
          {
            path: "versions/:licenceId/licence-transfer/:licenceTransferId",
            element: <LicenceTransfer />,
          },
          {
            path: "compliance/sitevisit/:siteVisitId",
            element: <SiteVisit />,
          },
          {
            path: "compliance/return/:licenseeReturnId",
            element: <LicenseeReturn />,
          },
          {
            path: "compliance/request-for-information/:requestForInformationId",
            element: <RequestForInformation />,
          },
          {
            path: "compliance/finding-and-recommendation/:findingAndRecommendationId",
            element: <FindingAndRecommendation />,
          },
          {
            path: "compliance/action-or-instruction/:actionOrInstructionId",
            element: <ActionOrInstruction />,
          },
          {
            path: "compliance/lr-instruction/:instructionId",
            element: <Instruction />,
          },
          {
            path: "compliance/epa-correspondence/:epaCorrespondenceId",
            element: <EpaCorrespondence />,
          },
          {
            path: "compliance/3rd-party-correspondence/:thirdPartyCorrespondenceId",
            element: <ThirdPartyCorrespondence />,
          },
          {
            path: "compliance/eden-message/:edenMessageId",
            element: <EdenMessage />,
          },
          {
            path: "compliance/investigation/:complianceInvestigationId",
            element: <ComplianceInvestigation />,
          },
          {
            path: "compliance/incident/:incidentId",
            element: <Incident />,
          },
          {
            path: "compliance/incident-update-request/:incidentUpdateRequestId",
            element: <IncidentUpdateRequest />,
          },
          {
            path: "compliance/complaint/:complaintId",
            element: <Complaint />,
          },
          {
            path: "compliance/meeting/:meetingId",
            element: <Meeting />,
          },
          {
            path: "compliance/non-compliance/:nonComplianceId",
            element: <NonCompliance />,
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
